import {
  updateAssetAssetPut,
  updateAssetsAssetsPut,
} from "@phc/common/gen/preferencesGen"
import { useMutation } from "@tanstack/react-query"
import { useSnackbar } from "notistack"
import type { AssetInput } from "../../../../utils/preferencesApi"
import { useInvalidateAssetQueries } from "../../hooks/useAssetService"

export const useUpdateAsset = () => {
  const { invalidateAssetQueries } = useInvalidateAssetQueries()
  const { enqueueSnackbar } = useSnackbar()
  const successMessage = "Your location has been updated."
  return useMutation({
    mutationFn: (variables: { asset: AssetInput }) =>
      updateAssetAssetPut({ asset: variables.asset }),
    onError: err => {
      enqueueSnackbar("Unable to update this location.", {
        variant: "error",
      })
      console.error(err)
    },
    onSuccess: () => {
      enqueueSnackbar(successMessage, {
        variant: "success",
      })
    },
    onSettled: async () => {
      await invalidateAssetQueries()
    },
  })
}

export const useUpdateAssets = () => {
  const { invalidateAssetQueries } = useInvalidateAssetQueries()
  const { enqueueSnackbar } = useSnackbar()
  const typeText = "locations"
  const successMessage = `Your ${typeText} have been updated.`
  return useMutation({
    mutationFn: (variables: { assets: AssetInput[] }) =>
      updateAssetsAssetsPut({ assets: variables.assets }),
    onError: err => {
      enqueueSnackbar(`Unable to update your ${typeText}.`, {
        variant: "error",
      })
      console.error(err)
    },
    onSuccess: () => {
      enqueueSnackbar(successMessage, {
        variant: "success",
      })
    },
    onSettled: async () => {
      await invalidateAssetQueries()
    },
  })
}
